import React from 'react';
import AddFormProto from "app/quick-add/sections/project/form/new-project-form-proto.tsx";

import Form from '../../../../../../core/gd-form/form/deprecated/form-add/form-add';
import FormManager from 'src/core/gd-form/common/form-manager';

import Api from '../../../../../../core/gd/api/api';
import ErrorBoundary from "../../../../../../core/error-boundary";
import _ from "lodash";
import {newProject_getFormFieldsProto} from "app/quick-add/sections/project/form/common";

class ComponentName extends AddFormProto {

    constructor(props) {
        super(props,  gd.const.project.type.BACKLOG);

        const { template } = this.props;

        let copyOptions = [];
        if (template.templateContent) {
            const { events, subProjects, tasks } = template.templateContent;
            if (events)         copyOptions.push("events");
            if (subProjects)    copyOptions.push("subProjects");
            if (tasks)          copyOptions.push("tasks");
        }

        // FORM
        const initFormData = {
            company: gd.companyId,
            parentProject: this.initProjectId,
            name: '',
            owner: null, //gd.session.me.id,

            color: this.defaultColor,
            defaultView: template.defaultView,

            deadline: null,
            copyOptions: copyOptions,
        };

        const formStructure = {
            fields: _.merge(newProject_getFormFieldsProto(this), {}),
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);

    }

    onSubmit = (result) => {

        const { copyOptions } = result;

        const newProjectData = {

            toCompanyId: gd.companyId,
            toProjectId: result.parentProject,

            templateId: this.props.template.id,
            wipeTemplateContent: !this.state.copyToMyTemplates,
            name: result.name,
            // prefix: result.prefix,

            color: result.color,
            defaultView: result.defaultView,
            ownerUserId: result.owner,
            // deadline: result.deadline,

            copyTasks:          copyOptions.includes("tasks"),
            copySubProjects:    copyOptions.includes("subProjects"),
            copyEvents:         copyOptions.includes("events"),
        };


        let request;
        if (this.state.copyToMyTemplates) {
            request = Api.Project.newProjectFromSharedTemplate(newProjectData);
        } else {
            request = Api.Project.newProjectWithoutLocalTemplate(newProjectData);
        }

        request.done((data)=>{
            this.onProjectCreated(data);
        });
    }

    render() {

        return (
            <Form form={this.form} submitBtnClass="grey">

                <div className="tbl">

                    <ErrorBoundary>

                    {this.renderSelectParent()}
                    {this.renderNameAndColor()}
                    {this.renderCopyToMyTemplates()}

                    </ErrorBoundary>

                </div>

            </Form>
        );

    }

}

module.exports = ComponentName;